import { apiClient } from "@/core/api/ApiClient";
import { EntityType, VisualInspectionDto } from "@/core/api/generated/v1";

import BaseEntityDeleteModal, {
  BaseEntityDeleteModalInheritableProps,
} from "../components/BaseEntityDeleteModal";

export interface OwnProps {
  entity: VisualInspectionDto;
}

type Props = OwnProps & BaseEntityDeleteModalInheritableProps;

export default function VisualInspectionDeleteModal({ entity, ...otherProps }: Props) {
  return (
    <BaseEntityDeleteModal
      entityType={EntityType.VisualInspection}
      entity={entity}
      entityId={entity.id}
      deleteFunc={async (params) => {
        await apiClient.visualInspectionsApi.apiV1VisualInspectionsVisualInspectionIdDelete({
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          visualInspectionId: params.entityId,
          isDeleteCascade: params.isDeleteCascade,
        });
      }}
      {...otherProps}
    />
  );
}
